import api from '@pray/shared/utils/api';

export type TranslationError = {
  code?: string;
  message?: string;
  source?: string;
};

export type SystemCheckTranslation = {
  content_localized_id: string;
  content_localized_title: string;
  content_title: string;
  content_public_id: string;
  content_localized_public_id: string;
  artist_name: string;
  artist_id: string;
  locale_code: string;
  locale_label: string;
  locale_icon_url: string;
  translation_status: string;
  translation_error: TranslationError | null;
  created_at: string;
  translation_triggered_at: string;
};

export type SystemCheckTranslationsResponse = {
  data: SystemCheckTranslation[];
  pagination: {
    next_cursor: string | null;
    has_more: boolean;
    total_count: number;
  };
};

export type GetSystemCheckTranslationsParams = {
  mediaType: string;
  cursor?: string | null;
  limit?: number;
};

export async function getSystemCheckTranslations({
  mediaType,
  cursor = null,
  limit = 50,
}: GetSystemCheckTranslationsParams): Promise<SystemCheckTranslationsResponse> {
  const params: Record<string, string | number> = {
    media_type: mediaType,
    limit,
  };

  if (cursor) params.cursor = cursor;

  const url = '/web/studio/system-check/translations';
  const response = await api.executeGetRequest<{ data: SystemCheckTranslationsResponse }>(url, params);

  return response.data.data;
}
